export default __webpack_public_path__ + "static/media/Cairo-SemiBold.9984e1e2.ttf";